module.exports = __webpack_public_path__ + "static/media/cross-neurips26.a0902e85.png";